
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { ContactModel } from './Entities.GormCrm.Contact';
import { Model, ModelProperty } from 'models/Model';


export class ContactPhoneModel extends Model<ContactPhoneModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'string', isHidden: true },
		{ name: 'contactId', type: 'string' },
		{ name: 'number', type: 'string' },
		{ name: 'created', type: 'Date', isHidden: true },
		{ name: 'priority', type: 'number' },
		{ name: 'mobile', type: 'boolean' },
		{ name: 'contact', type: 'ContactModel', isHidden: true, isObject: true, new: () => { return new ContactModel }, properties: () => { return ContactModel.classProperties } }
	];
	[key: string]: any;
	
	public id?: string;
	public contactId?: string;
	public number: string;
	public created?: Date;
	public priority: number;
	public mobile?: boolean;
	public contact?: ContactModel;
    
	constructor(){
		super();
		this.id = undefined;
		this.contactId = undefined;
		this.number = '';
		this.created = undefined;
		this.priority = 0;
		this.mobile = undefined;
		this.contact = undefined;
		
	}
	getProperties(){
		return ContactPhoneModel.classProperties;
	}
}

